import { handleResponse } from "../components/common/HandleResponse";
import { authenticationService } from "./authentication.service";

export const apiService = {
    fetchApiRequest,
    getPdfFile
};

/**
 * Provede fetch pro zadanou URL na server, zkontroluje případně autentizaci a vrátí výsledek.
 *
 * @param {*} requestUrl
 * @param {boolean} [authenticate=true]
 * @param {*} requestOptions
 * @returns
 */
function fetchApiRequest(requestUrl, authenticate = true, requestOptions) {
    return fetch(requestUrl, requestOptions || !authenticate ? requestOptions : authenticationService.requestOptions).then(handleResponse);
}

function getPdfFile(requestUrl, onloadHandler, onerrorHandler, authenticate = true) {
    var oReq = new XMLHttpRequest();

    var URLToPDF = requestUrl;

    oReq.open("GET", URLToPDF, true);

    if (authenticate) {
        // add authorization header with jwt token
        const currentUser = authenticationService.currentUserValue;
        oReq.setRequestHeader("Authorization", `Bearer ${currentUser.token}`);
    }

    oReq.responseType = "blob";

    oReq.onload = async function() {
        if (oReq.status == 400 || oReq.status == 500) {
            if (onerrorHandler) {
                const error = new Blob([oReq.response], { type: "text/plain" });
                onerrorHandler(await error.text());
            }
            return;
        }

        // Once the file is downloaded, open a new window with the PDF
        // Remember to allow the POP-UPS in your browser
        const file = new Blob([oReq.response], { type: "application/pdf" });

        const fileURL = URL.createObjectURL(file);

        if (onloadHandler) {
            onloadHandler(fileURL);
        }
    };

    oReq.send();
}



// WEBPACK FOOTER //
// ./src/services/api.service.js